import { render } from "./TokenEditor.vue?vue&type=template&id=610f5cc9&scoped=true"
import script from "./TokenEditor.vue?vue&type=script&lang=js"
export * from "./TokenEditor.vue?vue&type=script&lang=js"

import "./TokenEditor.vue?vue&type=style&index=0&id=610f5cc9&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610f5cc9"]])

export default __exports__